// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelDomain-Components-StatusTag-css-module__statusTag--Iw8kV"};